import { render, staticRenderFns } from "./OnlineTutorialsTable.vue?vue&type=template&id=3cf85c94&"
import script from "./OnlineTutorialsTable.vue?vue&type=script&lang=js&"
export * from "./OnlineTutorialsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports